// src/components/common/RoleBasedComponent.jsx
import { useContext } from 'react';
import { userContext } from '../../context/ContextProvider';

/**
 * RoleBasedComponent
 * Conditionally renders children based on user role
 *
 * @param {ReactNode} children
 * @param {string[]} allowedRoles - e.g. ['superadmin', 'admin']
 */
const RoleBasedComponent = ({ children, allowedRoles = [] }) => {
  const { role } = useContext(userContext);

  // If role not yet available or user not logged in → render nothing
  if (!role) return null;

  const userRole = role.toLowerCase();

  // Role not allowed
  if (!allowedRoles.map(r => r.toLowerCase()).includes(userRole)) {
    return null;
  }

  return children;
};

export default RoleBasedComponent;
